import { Box, Button } from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";
import {darken, lighten} from "@mui/material";

export default function BasicActionButton({ type = "submit", label, action, disabled, sx, withIcon = true, buttonBordered, useBorderColor='#115d82', useDark, iconStyle }) {
    return(
        <Box sx={{height: '40px', ...sx}}>
            <Button
                sx={buttonBordered ?
                    {
                        ...styles.buttonBordered, ...sx,
                        ...{
                            color: useBorderColor,
                            borderColor: useBorderColor,
                            ':hover': {
                                backgroundColor: '#ffffff',
                                color: darken(useBorderColor, 0.9),
                                borderColor: darken(useBorderColor, 0.9)
                            },
                            ':disabled': {
                                backgroundColor: '#ffffff',
                                color: lighten(useBorderColor, 0.55),
                                borderColor: lighten(useBorderColor, 0.55)
                            },
                            ':active': {
                                color: useBorderColor
                            },
                        }
                    }
                    : (useDark ? styles.buttonColoredDark : {...styles.buttonColored, ...sx})}
                type={type}
                onClick={action}
                variant="contained"
                disableElevation
                disabled={disabled}
                endIcon={disabled && withIcon &&
                    <CircularProgress size={15} sx={{ color: '#ffffff', marginLeft: '10px', ...iconStyle}}/>} >
                {label}
            </Button>
        </Box>
    )
}

const styles = {
    buttonColored: {
        width: '100%',
        fontSize: '16px',
        padding: '11px 24px',
        color: '#0f0a06',
        fontFamily: 'FustatSemiBold',
        lineHeight: 1,
        textTransform: 'none',
        borderRadius: '50px',
        backgroundColor: '#74c4ec',
        ':hover': {
            backgroundColor: '#54b0e6',
            color: '#0f0a06',
        },
        ':disabled': {
            color: '#3f3c39',
            backgroundColor: '#89cdef'
        },
        ':focus': {
            outline: '0'
        }
    },
    buttonColoredDark: {
        width: '100%',
        fontSize: '16px',
        padding: '11px 24px',
        color: '#fff',
        fontFamily: 'FustatSemiBold',
        lineHeight: 1,
        textTransform: 'none',
        borderRadius: '50px',
        backgroundColor: '#191916',
        ':hover': {
            backgroundColor: '#171713',
            color: '#fff',
        },
        ':disabled': {
            color: '#fff',
            backgroundColor: '#282825'
        },
        ':focus': {
            outline: '0'
        }
    },
    buttonBordered: {
        width: '100%',
        fontSize: '16px',
        padding: '9px 25px',
        color: '#115d82',
        fontFamily: 'FustatSemiBold',
        lineHeight: 1,
        textTransform: 'none',
        borderRadius: '50px',
        backgroundColor: '#ffffff',
        border: '1.5px solid #115d82',
        textDecoration: 'none',
        ':hover': {
            backgroundColor: '#ffffff',
            color: '#1d465c',
            border: '1.5px solid #1d465c',
        },
        ':disabled': {
            color: '#456575',
            backgroundColor: '#ffffff',
            border: '1px solid #456575'
        },
        ':focus': {
            outline: '0'
        }
    },
}